import { render } from "./FileManager.vue?vue&type=template&id=3ba8d438&scoped=true"
import script from "./FileManager.vue?vue&type=script&lang=js"
export * from "./FileManager.vue?vue&type=script&lang=js"

import "./FileManager.vue?vue&type=style&index=0&id=3ba8d438&scoped=true&lang=css"

import exportComponent from "E:\\1402\\Back\\API_Core\\ApiCore\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba8d438"]])

export default __exports__